<template>
    <div style="height: 100%;padding: 5px;">
        <van-nav-bar
        title="消费"
        left-text="返回"
        left-arrow
        @click-left="historyBack"
      />
        <el-form ref="form" :model="addCash" size="mini" :rules="rules" label-width="80px">
            <el-form-item label="会员卡号" prop="cardnumber"> 
                <el-input v-model="addCash.cardnumber" size="mini" @change="getCardInfoByCourse"></el-input>
            </el-form-item>
            <el-form-item label="会员姓名" prop="membername">
                <el-input v-model="addCash.membername" size="mini" disabled></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="memberphone">
                <el-input v-model="addCash.memberphone" size="mini" disabled></el-input>
            </el-form-item>
        </el-form>
        <el-form size="mini" class="myform" style="margin-bottom: 30px;">
            <div v-for="(item,index) in cardcourse" :key="index" style="border-bottom: 1px solid #DCDFE6;padding-bottom: 10px;">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="疗程名称"> 
                            {{item.projectname}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="消费次数">
                            <el-input-number v-model="item.number" size="mini" :min="1" :max="10" label="描述文字"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="操作人">
                            <el-select v-model="item.staffid1" placeholder="请选择" style="width: 100%;" @change="staffChange(item)" size="mini">
                                <el-option v-for="item in staffInfos" :key="item.staffid" :label="item.staffname" :value="item.staffid">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="剩余次数">
                            {{item.restnumber}}
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <el-form-item>
                <el-button type="primary" style="width: 100%;" size="mini" :loading="queryLoadBtton" @click="saveCash">保存</el-button>
            </el-form-item>
        </el-form>
        <el-dialog title="会员卡信息" :visible.sync="carddialogVisible" width="100%" top="0px" :lock-scroll="false">
            <el-table border :data="cardList" size="mini" style="text-align: center" highlight-current-row>
                <el-table-column align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="setCardInfo(scope.row)">选择</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="合作门店" align="center"prop="hzstorename"></el-table-column>
                <el-table-column label="会员卡号" align="center"prop="cardnumber"></el-table-column>
                <el-table-column label="会员姓名" align="center"prop="membername"></el-table-column>
                <el-table-column label="手机号码" align="center"prop="memberphone"></el-table-column>
                <el-table-column label="储值余额" align="center"prop="balance"></el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                staffid:localStorage.getItem("staffid"),
                queryLoadBtton:false,
                rules:{
                    cardnumber: [
                        {required: true, message: "请输入会员卡号", trigger: 'blur'}
                    ],
                },
                cardcourse:[],
                carddialogVisible:false,
                storeid:localStorage.getItem("storeid"),
                cardList:[],
                cash:{
                    storeid:"",
                    sysbillid:"",
                    cardid:"",
                    cardnumber:"",
                    cardtypeid:"",
                    membername:"",
                    memberid:"",
                    sex:"2",
                    memberphone:"",
                    sid:"",
                    handbillid:"",
                    remarks:"",
                    paystatus:1,
                    accountdate:this.$moment().format('YYYY-MM-DD'),
                    createdate:"",
                    createtor:"",
                    createtorname:"",
                    billsource:1,
                    custnumber:1,
                    beltstaffid:"",
                    isback:0,
                    backsysbillid:"",
                    cardnature:1,
                    ticketno:"",
                    tickettype:2
                },
                addCash:{

                },
                staffMap:[],
                staffInfos:[],
            }
        },
        created() {
            this.getStaffByJob();
            let cardnumber=this.$route.query.cardnumber;
            if(cardnumber){
                this.addBill();
                this.addCash.cardnumber=cardnumber;
                this.getCardInfoByCourse();
            }
        },
        methods:{
            staffChange(item){
                let staff=this.staffMap[item.staffid1];
                item.staffnumber1=staff.number;
                item.staffname1=staff.staffname;
            },
            addBill(){
                this.addCash=this.$copy(this.cash);
                this.cardcourse=[];
            },
            saveCash(){
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        let cashdetals=[];
                        this.queryLoadBtton=true;
                        if(this.cardcourse==null || this.cardcourse.length<1){
                            this.queryLoadBtton=false;
                            this.$message.error("该会员没有疗程可以消费");
                            return;
                        }
                        for(let val of this.cardcourse){
                            if(this.$parseInt(val.number)>0){
                                let cashdetal=new Object();
                                cashdetal.projectid=val.projectid;
                                cashdetal.projectname = val.projectname;
                                cashdetal.projectbigtype = val.projectbigtype;
                                cashdetal.projecttype = val.projecttype;
                                cashdetal.pricetype = 1;
                                cashdetal.number = val.number;
                                cashdetal.projecttotaltype=val.projecttotaltype1;
                                cashdetal.coursebuydate=val.buydate;
                                cashdetal.type = 6;
                                //计算单次金额
                                let oneprice = this.$parseInt(this.$parseInt(val.restamount) / this.$parseInt(val.restnumber));
                                cashdetal.stdprice = oneprice;
                                cashdetal.realamount = oneprice*val.number;
                                cashdetal.payid = "d40ab78fe5964531bee7de5e318a2ef1";
                                cashdetal.payname = "疗程支付";
                                cashdetal.restnumber = val.restnumber;
                                cashdetal.restamount = val.restamount;
                                cashdetal.isdiscount = 1;
                                cashdetal.isupdateprice = 1;
                                cashdetal.courseseq = val.courseid;
                                cashdetal.courseid = val.yearcourseid;
                                cashdetal.projectid = val.projectid;
                                cashdetal.yearcount=val.defaultnumber;
                                cashdetal.payamount=cashdetal.realamount;
                                cashdetal.payamount2=0;
                                cashdetal.payamount3=0;
                                cashdetal.staffid1=val.staffid1;
                                cashdetal.staffname1=val.staffname1;
                                cashdetal.staffnumber1=val.staffnumber1;
                                let totalpayamount=this.$parseInt(val.payamount1)+this.$parseInt(val.payamount2)+this.$parseInt(val.payamount3);
                                if(val.payid1!=null && val.payid1!=""){
                                    cashdetal.courselv1=this.$parseInt(val.payamount1)/this.$parseInt(totalpayamount);
                                    cashdetal.coursepayamount1=cashdetal.courselv1*this.$parseInt(cashdetal.realamount);
                                }
                                if(val.payid2!=null && val.payid2!=""){
                                    cashdetal.courselv2=this.$parseInt(val.payamount2)/this.$parseInt(totalpayamount);
                                    cashdetal.coursepayamount2=cashdetal.courselv2*this.$parseInt(cashdetal.realamount);
                                }
                                if(val.payid3!=null && val.payid3!=""){
                                    cashdetal.courselv3=this.$parseInt(val.payamount3)/this.$parseInt(totalpayamount);
                                    cashdetal.coursepayamount3=cashdetal.courselv3*this.$parseInt(cashdetal.realamount);
                                }
                                cashdetal.coursepayid1=val.payid1;
                                cashdetal.coursepayid2=val.payid2;
                                cashdetal.coursepayid3=val.payid3;
                                cashdetal.groupidx=cashdetal.length;
                                cashdetals.push(cashdetal);
                            }
                        }
                        if(cashdetals==null || cashdetals<1){
                            this.$message.error("请选择需要消费的疗程");
                            this.queryLoadBtton=false;
                            return;
                        }


                        let isstaff=true;
                        for(let val of cashdetals){
                            if(!val.staffid1){
                                isstaff=false;
                                break;
                            }
                        }

                        if(isstaff==false){
                            this.queryLoadBtton=false;
                            this.$message.error("请选择操作人员");
                            return;
                        }

                        this.addCash.createtor=localStorage.getItem("staffid");
                        this.addCash.createtorname=localStorage.getItem("staffname");
                        this.addCash.storename=localStorage.getItem("storename");
                        this.addCash.storeid=this.storeid;
                        let cashVo=new Object();
                        cashVo.cash=this.addCash;
                        cashVo.cashDetals=cashdetals;
                        this.$postw("cash/saveCash",cashVo).then(res=>{
                            this.queryLoadBtton=false;
                            if(res.sucess){
                                this.$message({message: '保存成功', type: 'success'});
                                this.$router.push({
                                    path:"/headstaff"
                                });
                                this.addBill();
                            }
                            else{
                                this.$message.error(res.message);
                            }
                        });
                    }
                });
            },
            getStaffByJob() {
                this.$post("inteboStaff/getStaffByInteboHasBill",{storeid:this.storeid}).then(res=>{
                    if(res.sucess){
                        this.staffInfos=res.object;
                        if(res.object!=null && res.object.length>0){
                            for(let val of this.staffInfos){
                                this.staffMap[val.staffid]=val;
                            }
                        }
                        
                    }
                    else{
                        this.$message.error(res.$message);
                    }
                });
            },
            getCardCourseByCardId(cardid){
                this.$post("cardinfo/getCardCourseByCardId",{cardid:cardid,showRest:0}).then(res=>{
                    if(res.sucess){
                        this.cardcourse=res.object;

                        if(this.cardcourse!=null && this.cardcourse.length>0){
                            for(let val of this.cardcourse){
                                this.$set(val,"staffid1",localStorage.getItem("staffid"));
                            }
                        }
                    }
                    else{
                        this.$message.error(res.$message);
                    }
                });
            },
            setCardInfo(cardinfo){
                this.addCash.cardid=cardinfo.cardid;
                this.addCash.cardtypeid=cardinfo.cardtypeid;
                this.addCash.memberid=cardinfo.memberid;
                this.addCash.membername=cardinfo.membername;
                this.addCash.memberphone=cardinfo.memberphone;
                this.addCash.cardtypename=cardinfo.cardtypename;
                this.addCash.sex=cardinfo.sex;
                this.addCash.cardnumber=cardinfo.cardnumber;
                this.addCash.beltstaffid="";
                this.addCash.cardnature=cardinfo.cardnature;
                this.addCash.shareid=cardinfo.shareid;
                this.getCardCourseByCardId(cardinfo.cardid);
                this.carddialogVisible=false;
            },
            getCardInfoByCourse(){
                if(!this.addCash.cardnumber){
                    this.addCash.cardid="";
                    this.addCash.cardtypeid="";
                    this.addCash.memberid="";
                    this.addCash.membername="";
                    this.addCash.memberphone="";
                    this.addCash.cardtypename="";
                    this.addCash.sex="2";
                    this.addCash.beltstaffid="";
                    this.addCash.cardtypename="";
                    this.addCash.cardnature=1;
                    this.addCash.shareid="";
                    this.addCash.tickettype=2;
                    return;
                }
                this.$post("cardinfo/getCardInfoByCourse",{storeid:this.storeid,param:this.addCash.cardnumber}).then(res=>{
                    if(res.sucess){
                        if(res.object!=null && res.object.length==1){
                            let cardinfo=res.object[0];
                            this.addCash.cardid=cardinfo.cardid;
                            this.addCash.cardtypeid=cardinfo.cardtypeid;
                            this.addCash.memberid=cardinfo.memberid;
                            this.addCash.membername=cardinfo.membername;
                            this.addCash.memberphone=cardinfo.memberphone;
                            this.addCash.cardtypename=cardinfo.cardtypename;
                            this.addCash.sex=cardinfo.sex;
                            this.addCash.cardnumber=cardinfo.cardnumber;
                            this.addCash.beltstaffid="";
                            this.addCash.cardnature=cardinfo.cardnature;
                            this.addCash.shareid=cardinfo.shareid;
                            this.getCardCourseByCardId(cardinfo.cardid);
                        }
                        else if(res.object!=null && res.object.length>1){
                            this.carddialogVisible=true;
                            this.cardList=res.object;
                        }
                        else{
                            this.addCash.cardid="";
                            this.addCash.cardtypeid="";
                            this.addCash.memberid="";
                            this.addCash.membername="";
                            this.addCash.memberphone="";
                            this.addCash.cardtypename="";
                            this.addCash.sex="2";
                            this.addCash.beltstaffid="";
                            this.addCash.cardtypename="";
                            this.addCash.cardnature=1;
                            this.addCash.shareid="";
                            this.addCash.tickettype=2;
                        }
                    }
                    else{
                        this.addCash.cardid="";
                        this.addCash.cardtypeid="";
                        this.addCash.memberid="";
                        this.addCash.membername="";
                        this.addCash.memberphone="";
                        this.addCash.cardtypename="";
                        this.addCash.sex="2";
                        this.addCash.beltstaffid="";
                        this.addCash.cardtypename="";
                        this.addCash.cardnature=1;
                        this.addCash.shareid="";
                        this.addCash.tickettype=2;
                        this.$message.error(res.$message);
                    }
                });
            }
        }
    }
</script>
<style style lang="scss" rel="stylesheet/scss">
    .myform .el-input-number--mini{
        width: 110px;
    }
    .myform .el-form-item{
        margin-bottom:0px;
    }
</style>


// WEBPACK FOOTER //
// src/page/intebo/cash.vue